module.exports = __webpack_public_path__ + "static/media/PF.ff74caae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/PF.svg
// module id = 2236
// module chunks = 7